import React, { Component } from 'react'
import { Form, Select } from 'antd'
import { BreedContextData } from '../../../../context/BreedContext'
import { SpecieContextData } from '../../../../context/SpecieContext'

type MappingBreedFormProps = {
  form: any,

  breedContext: BreedContextData,
  specieContext: SpecieContextData
}

export default class MappingBreedForm extends Component<MappingBreedFormProps> {

  async componentDidMount() {
    const { form, specieContext, breedContext } = this.props

    let breedPayload: any = {
      options: {
        limit: 9999,
        sort: ['name']
      }
    }
    if (form) {
      breedPayload = {
        ...breedPayload,
        search: {
          specie: {
            with: {
              _exists: true,
              uuid: form.getFieldValue('specie_uuid')
            }
          }
        }
      }
    }

    await specieContext.requestSpecieList({
      options: {
        limit: 9999,
        sort: ['name']
      }
    })

    breedContext.requestBreedList(breedPayload)
  }

  handleChangeSpecie = async (specieUuid: string) => {
    const { form, breedContext } = this.props

    // If we have chosen a specie, we need to clear up the breed select
    form.setFieldsValue({
      breed_uuid: undefined
    })

    breedContext.requestBreedList({
      search: {
        specie: {
          has: {
            uuid: specieUuid
          }
        }
      },
      options: {
        limit: 9999,
        sort: ['name']
      }
    })
  }

  render() {
    const { breedContext, specieContext } = this.props

    const breedsOptions = breedContext.breeds?.map(breed => {
      return {
        label: breed.name,
        value: breed.uuid
      }
    }) as any
    const speciesOptions = specieContext.species?.map(specie => {
      return {
        label: specie.name,
        value: specie.uuid
      }
    }) as any

    return (
      <>
        <Form.Item
          label="Species"
          name="specie_uuid"
          rules={[
            {
              required: true,
              message: 'Missing a species'
            }
          ]}
        >
          <Select
            loading={specieContext.fetching || false}
            placeholder="Select a species"
            options={speciesOptions}
            onChange={(value: string) => this.handleChangeSpecie(value)}
            filterOption={(input, option) => {
              if (!option?.label || typeof option.label !== 'string') return false
    
              return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }}
            showSearch
          />
        </Form.Item>

        <Form.Item
          label="Breed"
          name="breed_uuid"
          rules={[
            {
              required: true,
              message: 'Missing an breed'
            }
          ]}
        >
          <Select
            loading={breedContext.fetching || false}
            placeholder="Select an breed"
            options={breedsOptions}
            filterOption={(input, option) => {
              if (!option?.label || typeof option.label !== 'string') return false
    
              return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }}
            showSearch
          />
        </Form.Item>
      </>
    )
  }
}
